/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { ClosedEnum } from "../types/enums.js";

/**
 * 过滤行政级别。
 */
export const GetMiscDistrictLevel = {
  Province: "province",
  City: "city",
  District: "district",
  Street: "street",
} as const;
/**
 * 过滤行政级别。
 */
export type GetMiscDistrictLevel = ClosedEnum<typeof GetMiscDistrictLevel>;

export const GetMiscDistrictLevel$zodSchema = z.enum([
  "province",
  "city",
  "district",
  "street",
]).describe("过滤行政级别。");

export type GetMiscDistrictRequest = {
  keywords?: string | undefined;
  adcode?: string | undefined;
  lat?: number | undefined;
  lng?: number | undefined;
  level?: GetMiscDistrictLevel | undefined;
  country?: string | undefined;
  limit?: number | undefined;
};

export const GetMiscDistrictRequest$zodSchema: z.ZodType<
  GetMiscDistrictRequest
> = z.object({
  adcode: z.string().describe(
    "中国行政区划代码精确查询（如 `110000`），同时返回下级行政区。",
  ).optional(),
  country: z.string().describe(
    "过滤国家代码（ISO 3166-1 alpha-2），如 `CN`、`JP`、`US`、`GB`。",
  ).optional(),
  keywords: z.string().describe("关键词搜索（城市名、区县名，支持中英文）。")
    .optional(),
  lat: z.number().describe("纬度，与 `lng` 配合使用，坐标反查附近地点。")
    .optional(),
  level: GetMiscDistrictLevel$zodSchema.optional(),
  limit: z.int().default(20).describe("返回数量上限，默认 `20`，最大 `100`。"),
  lng: z.number().describe("经度，与 `lat` 配合使用。").optional(),
});

/**
 * 请求参数错误。
 */
export type GetMiscDistrictBadRequestResponseBody = {
  code?: string | undefined;
  message?: string | undefined;
};

export const GetMiscDistrictBadRequestResponseBody$zodSchema: z.ZodType<
  GetMiscDistrictBadRequestResponseBody
> = z.object({
  code: z.string().optional(),
  message: z.string().optional(),
}).describe("请求参数错误。");

/**
 * 中心点坐标。
 */
export type Center = { lat?: number | undefined; lng?: number | undefined };

export const Center$zodSchema: z.ZodType<Center> = z.object({
  lat: z.number().optional(),
  lng: z.number().optional(),
}).describe("中心点坐标。");

export type GetMiscDistrictResult = {
  name?: string | undefined;
  level?: string | undefined;
  country?: string | undefined;
  country_code?: string | undefined;
  province?: string | undefined;
  city?: string | undefined;
  district?: string | undefined;
  street?: string | undefined;
  adcode?: string | undefined;
  citycode?: string | undefined;
  center?: Center | undefined;
  population?: number | undefined;
  timezone?: string | undefined;
};

export const GetMiscDistrictResult$zodSchema: z.ZodType<GetMiscDistrictResult> =
  z.object({
    adcode: z.string().optional(),
    center: z.lazy(() => Center$zodSchema).optional(),
    city: z.string().optional(),
    citycode: z.string().optional(),
    country: z.string().optional(),
    country_code: z.string().optional(),
    district: z.string().optional(),
    level: z.string().optional(),
    name: z.string().optional(),
    population: z.int().optional(),
    province: z.string().optional(),
    street: z.string().optional(),
    timezone: z.string().optional(),
  });

/**
 * 查询成功！返回匹配的行政区域列表。
 */
export type GetMiscDistrictResponseBody = {
  total?: number | undefined;
  results?: Array<GetMiscDistrictResult> | undefined;
};

export const GetMiscDistrictResponseBody$zodSchema: z.ZodType<
  GetMiscDistrictResponseBody
> = z.object({
  results: z.array(z.lazy(() => GetMiscDistrictResult$zodSchema)).optional(),
  total: z.int().optional(),
}).describe("查询成功！返回匹配的行政区域列表。");

export type GetMiscDistrictResponse =
  | GetMiscDistrictResponseBody
  | GetMiscDistrictBadRequestResponseBody;

export const GetMiscDistrictResponse$zodSchema: z.ZodType<
  GetMiscDistrictResponse
> = z.union([
  z.lazy(() => GetMiscDistrictResponseBody$zodSchema),
  z.lazy(() => GetMiscDistrictBadRequestResponseBody$zodSchema),
]);
